import React, {} from "react"
import {Box, Grid} from '@mui/material'
import CircularProgress from "@mui/material/CircularProgress";
import Modal from "@mui/material/Modal";
import '../../../css/InfluencerUpload.css'
import {gtag} from "ga-gtag";


const modalStyle = {
   display: 'flex',
   height: 'auto',
   // bgcolor: 'rgba(0,0,0,1)',
   minHeight: '100vh',
   minWidth: '100vw',
   overflowY: 'hidden',
   outline: 'none',
   zIndex: '9999',
};

export default function OpenSubscribePopup(
   event,
   icon_image,
   influencer,
   current_tier,
   minimum_tier,
   influencer_name,
   currency,
) {
   this.setState({ subscribe_popup_open: false, showLoader: true })

   event.stopPropagation();
   event.preventDefault();
   gtag('event', 'subscribe_popup_view', {
      'event_category': 'Lead',
      'event_label': 'Subscribe Popup View'
   })
   if ((this.state.subscribe_popup_influencer !== influencer) || (this.state.current_page !== 'creator')){
      this.getSubpopupInfo(influencer, currency)
   }
   this.setState(
      {
         // subscribe_popup_open: true,
         subscribe_popup_icon_image: icon_image,
         subscribe_popup_influencer: influencer,
         subscribe_popup_influencer_name: influencer_name,
         subscribe_popup_current_tier: current_tier,
         subscribe_popup_minimum_tier: minimum_tier,
      }
   );
   if (this.state.subpopup_tier_overwrite !== null){
      this.setState({
         subscribe_popup_current_tier: this.state.subpopup_tier_overwrite,
      })
   }
   if (this.state.subpopup_tier_async_overwrite !== null){
      this.setState({
         subscribe_popup_async_tier_access: this.state.subpopup_tier_async_overwrite,
      })
   }
   const media = document.querySelectorAll('video, audio')
         for (let i=0; i<media.length; i++) {
               media[i].pause()
         }

   setTimeout(() => {
      this.setState({ subscribe_popup_open: true, showLoader: false })
   }, 200)


   return (
      <Modal open={this.state.showLoader}>
         <Box style={modalStyle}
              sx={{
                 display: 'flex', width: '100%', height: '100%',
                 margin: 'auto', zIndex: '1000'
              }}>
            <Grid
               container
               spacing={0}
               direction="column"
               alignItems="center"
               justifyContent="center"
               style={{minHeight: '90vh'}}
            >
               <CircularProgress sx={{
                  color: 'var(--brand-color)',
               }}/>

               <p style={{
                  color: 'var(--primary-text-color)', fontSize: 'var(--medium-text)',
                  fontWeight: '600',
               }}>Loading Popup...</p>
            </Grid>
         </Box>
      </Modal>
   )
}
